import { render, staticRenderFns } from "./KnowledgeOfAct.vue?vue&type=template&id=48aedd11&"
import script from "./KnowledgeOfAct.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeOfAct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports